import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { AccessControl } from "../interfaces/AccessControl";

interface Props {
  onAuthError?: () => void;
}
export default class AccessControlApis extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly ACCESS_URL: string = `${config.apiGateway.WORK_API}/api/access`;
  private static readonly RESULTS_URL: string = `${config.apiGateway.UTP2_API}/api/Results`;
  private static readonly REPORTS_URL: string = `${config.apiGateway.UTP2_API}/api/Reports`;

  getUserPermissions = (): Promise<AccessControl[]> => {
    return this.apiResponseHandler.get(AccessControlApis.ACCESS_URL).then((data) => {
      if (!data) {
        return [];
      }
      if (!Array.isArray(data)) {
        return [];
      }
      return data;
    });
  };

  isExpertOrGreater = async (customerId: number, substationId?: number, substationName?: string): Promise<boolean> => {
    let apiAccessControl = `${AccessControlApis.RESULTS_URL}`;

    if (substationId !== undefined) apiAccessControl = `${apiAccessControl}/substation/${customerId}/${substationId}`;
    else apiAccessControl = `${apiAccessControl}/substation/${customerId}/${substationName}`;

    return await this.apiResponseHandler.get(apiAccessControl);
  };
}
